













































import { Component, Vue, Ref } from 'vue-property-decorator';
import { GQL_recurringOrder_recurringOrder } from '@/queries/__generated__/recurringOrder';
import Order from '@/components/Invoicing/Order/Order.vue';
import { UPDATE_RECURRING_ORDER } from '@/queries/RecurringOrder';
import { modifyOrderData } from '@/app/Order';
import { UnsavedChanges } from '@/decorators/unsaved-changes';
import RecurringOrderSettingForm from '@/components/Invoicing/RecurringOrder/RecurringOrderSettingForm.vue';
import RecurringOrderEditControls from '@/components/Invoicing/RecurringOrder/Controls/RecurringOrderEditControls.vue';
import { formatRecurringOrderDataForMutation } from '@/app/RecurringOrder';
import i18n from '@/i18n';
import gql from 'graphql-tag';
import { recurringOrderFragments } from '@/queries/recurringOrderFragments';

const GET_RECURRING_ORDER = gql`
   query recurringOrder($id: ID!) {
    recurringOrder(id: $id) {
      ...recurringOrderFragments,
    }
  },
  ${recurringOrderFragments}
`;

@Component({
  components: {
    Order,
    RecurringOrderSettingForm,
    RecurringOrderEditControls,
  },
})
export default class RecurringOrdersEdit extends Vue {
  private GET_RECURRING_ORDER = GET_RECURRING_ORDER;
  private UPDATE_RECURRING_ORDER = UPDATE_RECURRING_ORDER;
  @Ref() public readonly orderRef!: Order;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  private data: { order: GQL_recurringOrder_recurringOrder } | null = null;
  private validOrderForm = true;
  private validRecurringOrderSettingForm = true;
  private modifyOrderData = modifyOrderData;

  @UnsavedChanges<RecurringOrdersEdit>({
    saveAndContinue() {
      return this.saveAndContinue();
    },
  }) public dirtyForm = false;

  private saveAndContinue() {
    if (!this.data) return false;
    return this.$apollo.mutate({
      mutation: UPDATE_RECURRING_ORDER,
      variables: formatRecurringOrderDataForMutation({ order: this.data.order }),
    }).then(() => {
      // i18n.t used instead of this.$t because function is async and component calling it might be destroyed, making 'this' undefined
      this.$sMessage.success(i18n.t('Message.saveSuccess'));
      return true;
    }).catch(() => {
      return false;
    });
  }

  private resetFormDirty() {
    this.orderRef.formRef?.resetDirty();
  }
}
